// extracted by mini-css-extract-plugin
module.exports = {"img":"img-2k4jT","text":"text-13cdl"};